import * as yup from "yup"; 
import { StringOfMax60Chars } from "./strings";

export interface HasToJson {
    toJson: () => string
    parse: (str: string) => object
}
export interface HasValidationSchema {
    getValidationSchema: () => unknown
}

export type ResumableUploadAPIHandle = string;
/** Nota: "GIF" só está disponível para templates do tipo "MARKETING". */
export type MetaMediaHeaderFormat = 'image' | 'video' | 'gif' | 'document';
type MetaHeaderType = 'text' | 'location' | 'image' | 'video' | 'gif' | 'document';
abstract class aMetaTemplateHeader {
    type = 'header'
    constructor(
        public format: MetaHeaderType,
    ) {}
}

/** Notes: Headers can only have one parameter. */
export type MetaTemplateHeader_CRUD = MetaTextHeader_CRUD | MetaMediaHeader_CRUD //| MetaLocationHeader_CRUD;
export type MetaTemplateHeader_SEND = MetaTextHeader_CRUD | MetaMediaHeader_SEND //| MetaLocationHeader_SEND;

export type MetaTextHeader_CRUD = MetaParameterlessTextHeader_CRUD | MetaNamedParameterTextHeader_CRUD | MetaPositionalParameterTextHeader_CRUD;

// Text Headers
export class MetaParameterlessTextHeader_CRUD extends aMetaTemplateHeader implements HasToJson, HasValidationSchema {
    constructor(
        public text: StringOfMax60Chars = '' as StringOfMax60Chars
    ) { super('text') }
    toJson() { 
        return JSON.stringify({
            type: 'header',
            format: 'text',
            text: this.text,
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "header", format: 'text', text: StringOfMax60Chars }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(60, 'O texto do header pode ter até 60 caracteres.'),
        }) //as ReturnType<typeof yup.object>
    }
}

export class MetaNamedParameterTextHeader_CRUD extends aMetaTemplateHeader implements HasToJson, HasValidationSchema  {
    constructor(
        public text: string = '',
        public example_headerTextNamedParams?: { param_name: string, example: string }
    ) { super('text') }
    toJson() { 
        return JSON.stringify({
            type: 'header',
            format: 'text',
            text: this.text,
            example: {
                header_text_named_params: this.example_headerTextNamedParams ? [this.example_headerTextNamedParams] : []
            }
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "header", format: 'text', text: StringOfMax60Chars, example: { header_text_named_params: [{ param_name: string, example: string }] } }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(60, 'O texto do header pode ter até 60 caracteres.'),
            example_headerTextNamedParams: yup.object({
                param_name: yup.string().matches(/^[a-z_]$/g).required('O nome do parâmetro é obrigatório.'),
                example: yup.string().required('Um examplo de uso é obrigatório.')
            })
        })
    }
}

export class MetaPositionalParameterTextHeader_CRUD extends aMetaTemplateHeader implements HasToJson, HasValidationSchema  {
    constructor(
        public text: string = '',
        public example_headerText?: string
    ) { super('text') }
    toJson() {
        return JSON.stringify({
            type: 'header',
            format: 'text',
            text: this.text,
            example: {
                header_text: this.example_headerText ? [this.example_headerText] : []
            }
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "header", format: 'text', text: StringOfMax60Chars, example: { header_text: [string] } }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(60, 'O texto do header pode ter até 60 caracteres.'),
            example_headerText: yup.string().required('O parâmetro é obrigatório.')
        })
    }
}

// Media Headers
export class MetaMediaHeader_CRUD extends aMetaTemplateHeader implements HasToJson, HasValidationSchema  {
    constructor(
        format: MetaMediaHeaderFormat,
        public example_headerHandle: ResumableUploadAPIHandle
    ) { super(format) }
    toJson() {
        return JSON.stringify({
            type: 'header',
            format: this.format,
            example: {
                header_handle: [
                    `${this.example_headerHandle}`
                ]
            }
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "header", format: 'image'|'video'|'gif'|'document', text: StringOfMax60Chars, example: { header_handle: [ string ] } }
    }
    getValidationSchema() {
        return yup.object({
            header_handle: yup.string().required('O arquivo deve ser enviado via Resumable Upload API.')
        })
    }
}

export class MetaMediaHeader_SEND extends aMetaTemplateHeader implements HasToJson, HasValidationSchema  {
    constructor(
        format: MetaMediaHeaderFormat,
        public headerHandle: ResumableUploadAPIHandle
    ) { super(format) }
    toJson() {
        const params = `{ "type": "${this.format}", "${this.format}":"${this.headerHandle}" }`;
        return JSON.stringify({
            type: 'header',
            parameters: [JSON.parse(params)]
        })
    }
    parse(str: string) {
        throw new Error("You shouldn't be parsing strings to this class.");
        return JSON.parse(str) as object
    }
    getValidationSchema() {
        return yup.object({
            headerHandle: yup.string().required('O arquivo... pera que?')
        })
    }
}


// // Location Headers
// /** Detalhes específicos da localização são definidos no momento de ENVIO. */
// export class MetaLocationHeader_CRUD extends aMetaTemplateHeader {
//         constructor(
//     ) { super('location') }
// }

// /** @example "37.44211676562361" */
// export type LatLongStr = string
// export class MetaLocationHeader_SEND extends aMetaTemplateHeader {
//     constructor(
//         public parameters: [ {
//             type: "location",
//             location: {
//                 latitude: LatLongStr,
//                 longitude: LatLongStr,
//                 name: string,
//                 address: string
//             }
//          } ]
//     ) { super('location') }
// }